import { useEffect } from "react";
import { googleTagManagerKey } from "~/helpers/environment";

const loadGTM = () => {
  if (!googleTagManagerKey) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${googleTagManagerKey}`;
  document.head.appendChild(script);
};

export const GoogleTagManager = () => {
  useEffect(() => {
    if (!googleTagManagerKey) return;

    // Defer GTM until after first paint to improve FCP/LCP (non-critical for initial render)
    const loadAfterPaint = () => {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(loadGTM, { timeout: 2000 });
      } else {
        setTimeout(loadGTM, 1000);
      }
    };

    if (document.readyState === "complete") {
      loadAfterPaint();
    } else {
      window.addEventListener("load", loadAfterPaint);
      return () => window.removeEventListener("load", loadAfterPaint);
    }
  }, []);

  if (!googleTagManagerKey) return null;

  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${googleTagManagerKey}`}
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
        title="Google Tag Manager"
      />
    </noscript>
  );
};
